import { render, staticRenderFns } from "./RagAdditionalSourcesTable.vue?vue&type=template&id=1a8d0d3f&scoped=true"
import script from "./RagAdditionalSourcesTable.vue?vue&type=script&lang=js"
export * from "./RagAdditionalSourcesTable.vue?vue&type=script&lang=js"
import style0 from "./RagAdditionalSourcesTable.vue?vue&type=style&index=0&id=1a8d0d3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d0d3f",
  null
  
)

export default component.exports